const lightTheme = {
  color: "#010606",
  colorText: "#010606",
  backgroundColor: "#F2F2F2F2",
};

const darkTheme = {
  color: "#FFFFFF",
  colorText: "#caccd7",
  backgroundColor: "#1f2028",
};

export const themes = {
  Light: lightTheme,
  Dark: darkTheme,
};
